import { en } from './en';
import { fr } from './fr';
import { tr } from './tr';
import { de } from './de';

import LocalizedStrings from 'react-localization';

export const Translate = new LocalizedStrings({
    en: en,
    tr: tr,
    fr: fr,
    de: de,
});
